// Frontend mirror of /backend/recipes/shared/colorNames.ts.
// Standardizes certified color additive names to their FD&C form, so
// "Red #40", "Red Dye 40", "FD&C RED NO. 40" all read "FD&C Red 40".
//
// Lakes (e.g. "FD&C RED #40 ALUMINUM LAKE") keep the word "Lake" when
// KEEP_LAKE is true ("FD&C Red 40 Lake"): FDA labeling (21 CFR 101.22(k))
// declares a lake separately from the straight dye.
//
// Only the seven FD&C colors certified for food are touched; anything else
// (e.g. "Citrus Red 2", "Red Beet") is left as typed.

export const KEEP_LAKE = true

const CERTIFIED: Record<string, string[]> = {
  red: ['3', '40'],
  yellow: ['5', '6'],
  blue: ['1', '2'],
  green: ['3'],
}

const COLOR_RE =
  /(?<![A-Za-z0-9&])(?:(?:FD\s*&\s*C|FDC)\s*)?(?<!CITRUS\s+)\b(RED|YELLOW|BLUE|GREEN)\s*(?:DYE\s*)?(?:NO\.?\s*|#\s*)?0*(\d{1,2})\b(?:\s+DYE\b)?(\s+(?:ALUMINI?UM\s+|AL\.?\s+)?LAKE\b)?/gi

export function normalizeColorNames(text: string, keepLake = KEEP_LAKE): string {
  if (!text) return text
  return text.replace(COLOR_RE, (match, color: string, num: string, lake?: string) => {
    const c = color.toLowerCase()
    if (!CERTIFIED[c]?.includes(num)) return match
    const name = `FD&C ${c.charAt(0).toUpperCase()}${c.slice(1)} ${num}`
    return lake && keepLake ? `${name} Lake` : name
  })
}
